// AUTO-GENERATED by generate-zod-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { z } from 'zod'

export const projectSchema = z.object({
  id: z.string().max(100),
  orgId: z.string().max(100),
  workspaceId: z.string().max(100).optional(),
  userId: z.string().max(100).optional(),
  createdAt: z.string().max(200).datetime(),
  updatedAt: z.string().max(200).datetime(),
  metadata: z.record(z.string(), z.unknown()).optional(),
  extended: z.record(z.string(), z.unknown()).optional(),
  name: z.string().max(500).optional(),
  title: z.string().max(500),
  description: z.string().max(100000).optional(),
  completed: z.boolean(),
  status: z.string().max(50).optional(),
  sortOrder: z.number().int().min(0).max(999999).optional(),
  goalId: z.string().max(100).optional(),
  startAt: z.string().max(200).datetime().optional(),
  startedAt: z.string().max(200).datetime().optional(),
  dueAt: z.string().max(200).datetime().optional(),
  completedAt: z.string().max(200).datetime().optional(),
  archived: z.boolean(),
  codebaseId: z.string().max(100).optional(),
  sourceTemplateId: z.string().max(100).optional(),
  timeBudgetHours: z.number().optional(),
  categoryId: z.string().max(100).optional(),
  tagIds: z.array(z.string()).optional(),
  productId: z.string().max(100).optional(),
  roadmapId: z.string().max(100).optional(),
  initiativeId: z.string().max(100).optional(),
  version: z.number().int(),
  tenantId: z.string().max(100).optional(),
})

export type ProjectInput = z.infer<typeof projectSchema>
